export default __webpack_public_path__ + "static/media/kustomer.edf77f47.png";